module.exports = __webpack_public_path__ + "img/battery.df4b6af5.png";